module.exports = __webpack_public_path__ + "img/Base_DX.1bfc8ed0.png";